module.exports = __webpack_public_path__ + "static/media/template-banner@2x.dfd44981.png";